import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {toJS} from 'mobx';
import classnames from 'classnames';
import moment from 'moment';
import SingleTrip from 'ferries/Home/components/FerrySearchMask/SingleTrip';
import MultiTrip from 'ferries/Home/components/FerrySearchMask/MultiTrip';
import TypeTripRadios from 'ferries/Home/components/FerrySearchMask/TypeTripRadios';
import SwitchElement from 'ferries/helpers/SwitchElement';
import Collapse from 'react-bootstrap/lib/Collapse';
import {cleanHtml} from 'helpers/commonHelper';
import {
  justThePortName,
  ROUND_TRIP_TYPE,
  MULTI_TRIP_TYPE
} from 'ferries/Home/components/FerrySearchMask/helperStore';

const FerrySearchMask = ({store, classes, isStandard, isResults, showMobileTripType}) => {
  const wrapperRef = useRef(null);

  const searchMaskTabWrapperClasses = classnames('searchMask-tab-wrapper', classes);
  const searchMaskWrapperClasses = classnames('searchMask-wrapper', {
    'bg-snow': showMobileTripType
  });

  const {isMobile, isTablet, loading, triedToSubmit, showMask, showSwitchAccommodation, routes, typeTrip,
    transformedTrips: trips, noOfTrips, maxTrips, minTrips, searchAccommodation, errors, recentQueries,
    toggleMask, addTrip, removeTrip, fillWithQuery, setTypeTrip, setPort, fetchSuggestions,
    clearSuggestions, onSuggestionSelected, portString, swapPorts, setDate, setDates, onChangeSwitch,
    setPortByThreeLetterCode, onChangePopularPortCountry, product, submitForm, translations} = store;
  
  const onClickWrapper = (e) => {
    if (wrapperRef.current && e.target === wrapperRef.current ||
      isMobile && e.target.id === 'trip-information') {
      toggleMask();
    }
  };

  const collapsibleWrapperClasses = classnames('d-flex justify-content-between align-items-center', {
    'mb-3': !isTablet || isStandard,
    'cursor-pointer': isResults
  });
  
  const isRoundTrip = typeTrip === ROUND_TRIP_TYPE;
  const isMultiTrip = typeTrip === MULTI_TRIP_TYPE;
  const route = `${justThePortName(routes[0].dep)} - ${justThePortName(
    routes[isRoundTrip ? 0 : routes.length - 1].arr
  )}`;

  const {hideSearchMask, viewSearchMask, trips: tripsTr,
    searchAccommodation: searchAccommodationTr
  } = translations;

  return (
    <>
      <div className={searchMaskTabWrapperClasses}>
        <div className={searchMaskWrapperClasses} style={{borderRadius: '8px'}}>
          {isTablet && isResults &&
              <div
                className="mb-2 text-white text-small cursor-pointer d-flex align-items-center justify-content-between"
                onClick={toggleMask}
              >
                <span>{showMask ? hideSearchMask : viewSearchMask}</span>
                <i className={`ml-2 icon icon-sm ${showMask ? 'icon-up-arrow' : 'icon-down-arrow'}`}/>
              </div>
          }
          <div className={collapsibleWrapperClasses} ref={wrapperRef} onClick={onClickWrapper}>
            {(showMask || isStandard) ?
              <div className='w-1-1'>
                <TypeTripRadios
                  isMobile={isMobile}
                  isResults={isResults}
                  showMobileTripType={showMobileTripType}
                  typeTrip={typeTrip}
                  setTypeTrip={setTypeTrip}
                  translations={translations}
                />
              </div>
              :
              <div className="collapsed-trip-info">
                {isMultiTrip ? <>
                  {isTablet ? <>
                    <h2 className="font-bold">
                      {route}&nbsp;
                      <span className="font-normal">({routes.length} {tripsTr})</span>
                    </h2>
                    <div className="text-small">
                      {moment(routes[0].obDate).format('ddd DD MMM YYYY')  + ' - ' +
                       moment(routes[routes.length - 1].obDate).format('ddd DD MMM YYYY')}
                    </div>
                  </> : <div className="d-flex flex-wrap">{routes.map((actualTrip, index) => {
                    return (
                      <div
                        key={index}
                        className="pr-4 mr-4 border-white text-nowrap"
                        style={{borderRightStyle: routes.length -1 !== index ? 'dashed' : 'none'}}
                      >
                        <h2 className="font-bold">
                          {justThePortName(actualTrip.dep)} - {justThePortName(actualTrip.arr)}
                        </h2>
                        <div className="text-small">
                          {moment(actualTrip.obDate).format('ddd DD MMM YYYY')}
                        </div>
                      </div>
                    );
                  })}</div>
                  }</> :
                  <div className="trip-info">
                    <h2 className="font-bold" id='trip-information'>{route}</h2>
                    <div className="text-small" dangerouslySetInnerHTML={{__html: cleanHtml(
                      moment(routes[0].obDate).format('ddd DD MMM YYYY') + (isRoundTrip ? ' - ' : '') +
                      (isRoundTrip ? moment(routes[0].ibDate).format('ddd DD MMM YYYY') : '')
                    )}}></div>
                  </div>
                }
              </div>
            }
            {!isTablet && isResults &&
                <div
                  className="text-white rounded py-2 px-3 cursor-pointer border border-white text-nowrap"
                  onClick={toggleMask}
                >
                  <span>{showMask ? hideSearchMask : viewSearchMask}</span>
                  <i className={`ml-2 icon icon-sm ${showMask ? 'icon-up-arrow' : 'icon-down-arrow'}`}/>
                </div>
            }
          </div>
          <Collapse in={showMask || isStandard}  className={`${isResults ? 'mt-2' : ''}`}>
            <div>
              <div className="map-search">
                {
                  isMultiTrip ?
                    <MultiTrip
                      isMobile={isMobile}
                      loading={loading}
                      triedToSubmit={triedToSubmit}
                      trips={trips}
                      noOfTrips={noOfTrips}
                      maxTrips={maxTrips}
                      minTrips={minTrips}
                      queries={recentQueries}
                      errors={toJS(errors)}
                      addTrip={addTrip}
                      removeTrip={removeTrip}
                      setPort={setPort}
                      fetchSuggestions={fetchSuggestions}
                      clearSuggestions={clearSuggestions}
                      onSuggestionSelected={onSuggestionSelected}
                      portString={portString}
                      swapPorts={swapPorts}
                      setTypeTrip={setTypeTrip}
                      setDate={setDate}
                      setDates={setDates}
                      setPortByThreeLetterCode={setPortByThreeLetterCode}
                      fillWithQuery={fillWithQuery}
                      onChangePopularPortCountry={onChangePopularPortCountry}
                      submitForm={submitForm}
                      product={product}
                      translations={translations}
                    /> :
                    <SingleTrip
                      isMobile={isMobile}
                      loading={loading}
                      isRoundTrip={isRoundTrip}
                      triedToSubmit={triedToSubmit}
                      trips={trips}
                      queries={recentQueries}
                      errors={toJS(errors)}
                      setPort={setPort}
                      fetchSuggestions={fetchSuggestions}
                      clearSuggestions={clearSuggestions}
                      onSuggestionSelected={onSuggestionSelected}
                      portString={portString}
                      swapPorts={swapPorts}
                      setTypeTrip={setTypeTrip}
                      setDate={setDate}
                      setDates={setDates}
                      setPortByThreeLetterCode={setPortByThreeLetterCode}
                      fillWithQuery={fillWithQuery}
                      onChangePopularPortCountry={onChangePopularPortCountry}
                      submitForm={submitForm}
                      product={product}
                      translations={translations}
                    />
                }
              </div>
              {
                showSwitchAccommodation &&
                  <div className="d-flex align-items-center mb-2">
                    <SwitchElement
                      name="accommodation_switch"
                      field={searchAccommodation}
                      onChangeField={onChangeSwitch}
                    />
                    <span className="ml-3 pb-2">{searchAccommodationTr}</span>
                  </div>
              }
            </div>
          </Collapse>
        </div>
      </div>
    </>
  );
};

FerrySearchMask.propTypes = {
  store: PropTypes.shape({
    isMobile: PropTypes.bool.isRequired,
    isTablet: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    triedToSubmit: PropTypes.bool.isRequired,
    showMask: PropTypes.bool.isRequired,
    showSwitchAccommodation: PropTypes.bool.isRequired,
    product: PropTypes.string.isRequired,
    routes: PropTypes.array.isRequired,
    typeTrip: PropTypes.number.isRequired,
    trips: PropTypes.object.isRequired,
    transformedTrips: PropTypes.array.isRequired,
    noOfTrips: PropTypes.number.isRequired,
    maxTrips: PropTypes.number.isRequired,
    minTrips: PropTypes.number.isRequired,
    searchAccommodation: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    suggestionSelected: PropTypes.object,
    recentQueries: PropTypes.object.isRequired,
    toggleMask: PropTypes.func.isRequired,
    addTrip: PropTypes.func.isRequired,
    removeTrip: PropTypes.func.isRequired,
    fillWithQuery: PropTypes.func.isRequired,
    setPort: PropTypes.func.isRequired,
    fetchSuggestions: PropTypes.func.isRequired,
    clearSuggestions: PropTypes.func.isRequired,
    onSuggestionSelected: PropTypes.func.isRequired,
    portString: PropTypes.func.isRequired,
    swapPorts:PropTypes.func.isRequired,
    setTypeTrip: PropTypes.func.isRequired,
    setDate: PropTypes.func.isRequired,
    setDates: PropTypes.func.isRequired,
    setPortByThreeLetterCode: PropTypes.func.isRequired,
    onChangeSwitch: PropTypes.func.isRequired,
    onChangePopularPortCountry: PropTypes.func.isRequired,
    submitForm: PropTypes.func.isRequired,
    translations: PropTypes.shape({
      hideSearchMask: PropTypes.string.isRequired,
      viewSearchMask: PropTypes.string.isRequired,
      trips: PropTypes.string.isRequired,
      searchAccommodation: PropTypes.string.isRequired
    })
  }),
  isStandard: PropTypes.bool.isRequired,
  isResults: PropTypes.bool.isRequired,
  showMobileTripType: PropTypes.bool.isRequired,
  classes: PropTypes.string
};

FerrySearchMask.defaultProps = {
  isStandard: false,
  isResults: false,
  showMobileTripType: false
};

export default observer(FerrySearchMask);
